import { useEffect } from 'react'
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom'
import { getRouteLabel } from '@common/constants/routes'
import { pushVisitedPage } from '../helpers/navigationHistory'

/**
 * Records every navigation in the trail the back control reads, under the route's
 * own label.
 *
 * Mounted once in the app shell rather than per page, because a back button
 * cannot have holes: most pages never call `useSetPageTitle`, and before this they
 * were simply missing from the trail. A page that does name itself still wins —
 * `useSetPageTitle` pushes without `keepExistingTitle`, so its specific title
 * (a client's name, a BBC's date) replaces the label here regardless of which
 * effect runs last.
 */
export function useRecordVisit(): void {
  const { pathname, search } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    const label = getRouteLabel(pathname)
    if (label) {
      pushVisitedPage(
        { pathname, title: label, search },
        { keepExistingTitle: true, replace: navigationType === NavigationType.Replace },
      )
    }
  }, [pathname, search, navigationType])
}
